// gerado por scripts/gen-theme.ts a partir de scripts/theme/parties.source.ts — não editar (§3.3.9, §14.2.3)
import { pickInk } from './ink';

export interface PartyColors {
  fill: string;
  text: string;
  ink: string;
  /** m0…m3 (§3.3.4) */
  margin: [string, string, string, string];
  /** c0…c5 (§3.3.6) */
  candidate: [string, string, string, string, string, string];
  /** Face clara do pico no canvas: mistura OKLab de 20% em direção a #FAFAFA (§3.3.8). */
  peak: string;
}
export interface Party {
  code: string;
  number: number;
  display: string;
  name: string;
  federation: string | null;
  colors: PartyColors;
}

/** Partido sem cor (§3.3.2): número 0, display vazio, cores fallback. */
export const FALLBACK_PARTY: Party = {
  code: '', number: 0, display: '', name: '', federation: null,
  colors: { fill: '#978D82', text: '#978D82', ink: '#120F0D', margin: ['#63605B', '#736D66', '#857E75', '#978D82'], candidate: ['#504C4A', '#5D5954', '#6A6660', '#787169', '#888076', '#978D82'], peak: '#AAA299' },
};

/** Chave = party_code do TSE (sigla sem acento). */
export const PARTIES: Readonly<Record<string, Party>> = {
  PT: {
    code: 'PT', number: 13, display: 'PT', name: 'Partido dos Trabalhadores', federation: null,
    colors: { fill: '#E85854', text: '#E85854', ink: '#120F0D', margin: ['#894D49', '#A7504B', '#C95550', '#E85854'], candidate: ['#6C3F3A', '#85443F', '#9C4A46', '#B44D49', '#CF534F', '#E85854'], peak: '#F07C75' },
  },
  PL: {
    code: 'PL', number: 22, display: 'PL', name: 'Partido Liberal', federation: null,
    colors: { fill: '#4F8AFB', text: '#4F8AFB', ink: '#120F0D', margin: ['#47608E', '#486CB2', '#4C7CD7', '#4F8AFB'], candidate: ['#3A4D70', '#3D598C', '#4265A6', '#4470C0', '#4B7DDF', '#4F8AFB'], peak: '#71A2FD' },
  },
  REPUBLICANOS: {
    code: 'REPUBLICANOS', number: 10, display: 'Republicanos', name: 'Republicanos', federation: null,
    colors: { fill: '#A170EB', text: '#A170EB', ink: '#120F0D', margin: ['#685588', '#785DA8', '#8E67CA', '#A170EB'], candidate: ['#52456B', '#624D84', '#71569D', '#7F5DB5', '#9167D1', '#A170EB'], peak: '#B28DF0' },
  },
  PP: {
    code: 'PP', number: 11, display: 'PP', name: 'Progressistas', federation: null,
    colors: { fill: '#00A4A3', text: '#00A4A3', ink: '#120F0D', margin: ['#3E6969', '#327B7B', '#279090', '#00A4A3'], candidate: ['#325454', '#2E6463', '#2E7373', '#298181', '#1E9393', '#00A4A3'], peak: '#58B5B4' },
  },
  MDB: {
    code: 'MDB', number: 15, display: 'MDB', name: 'Movimento Democrático Brasileiro', federation: null,
    colors: { fill: '#04A881', text: '#04A881', ink: '#120F0D', margin: ['#3D6B5B', '#317E67', '#239475', '#04A881'], candidate: ['#345549', '#326554', '#30755F', '#28846A', '#1A9777', '#04A881'], peak: '#58B998' },
  },
  UNIAO: {
    code: 'UNIAO', number: 44, display: 'União', name: 'União Brasil', federation: null,
    colors: { fill: '#019BD5', text: '#019BD5', ink: '#120F0D', margin: ['#3B667F', '#31769B', '#2589B9', '#019BD5'], candidate: ['#335164', '#2E607B', '#2D6E91', '#257BA6', '#178CBF', '#019BD5'], peak: '#56AFDD' },
  },
  PSDB: {
    code: 'PSDB', number: 45, display: 'PSDB', name: 'Partido da Social Democracia Brasileira', federation: null,
    colors: { fill: '#B48703', text: '#B48703', ink: '#120F0D', margin: ['#705E37', '#856A2C', '#9E7920', '#B48703'], candidate: ['#594B2F', '#6A572B', '#7C6328', '#8D6D20', '#A17B17', '#B48703'], peak: '#C29E50' },
  },
  PSD: {
    code: 'PSD', number: 55, display: 'PSD', name: 'Partido Social Democrático', federation: null,
    colors: { fill: '#48A830', text: '#48A830', ink: '#120F0D', margin: ['#466C3F', '#467E39', '#489437', '#48A830'], candidate: ['#395634', '#3C6634', '#407635', '#418533', '#469732', '#48A830'], peak: '#70B95F' },
  },
  PDT: {
    code: 'PDT', number: 12, display: 'PDT', name: 'Partido Democrático Trabalhista', federation: null,
    colors: { fill: '#DE5797', text: '#DE5797', ink: '#120F0D', margin: ['#844C64', '#A14E73', '#C15385', '#DE5797'], candidate: ['#683E50', '#80435D', '#96496B', '#AC4C79', '#C65288', '#DE5797'], peak: '#E77BAA' },
  },
  MISSAO: {
    code: 'MISSAO', number: 14, display: 'Missão', name: 'Partido Missão', federation: null,
    colors: { fill: '#AD8B00', text: '#AD8B00', ink: '#120F0D', margin: ['#6E5F37', '#816C2C', '#987C21', '#AD8B00'], candidate: ['#574C2F', '#68582B', '#786528', '#887020', '#9B7E17', '#AD8B00'], peak: '#BCA14F' },
  },
  PSTU: {
    code: 'PSTU', number: 16, display: 'PSTU', name: 'Partido Socialista dos Trabalhadores Unificado', federation: null,
    colors: { fill: '#E85662', text: '#E85662', ink: '#120F0D', margin: ['#884D4E', '#A74F52', '#C9535B', '#E85662'], candidate: ['#6B3F3F', '#854345', '#9C494D', '#B44C52', '#CF5259', '#E85662'], peak: '#F07B7F' },
  },
  REDE: {
    code: 'REDE', number: 18, display: 'Rede', name: 'Rede Sustentabilidade', federation: null,
    colors: { fill: '#00A692', text: '#00A692', ink: '#120F0D', margin: ['#3B6B61', '#307D70', '#279281', '#00A692'], candidate: ['#31554E', '#2E655B', '#307468', '#268374', '#1D9584', '#00A692'], peak: '#58B7A6' },
  },
  PODE: {
    code: 'PODE', number: 20, display: 'Podemos', name: 'Podemos', federation: null,
    colors: { fill: '#B06AE0', text: '#B06AE0', ink: '#120F0D', margin: ['#6E5383', '#8359A0', '#9B62C1', '#B06AE0'], candidate: ['#584367', '#6A4A7F', '#7A5396', '#8A59AD', '#9E62C7', '#B06AE0'], peak: '#BF88E7' },
  },
  PCB: {
    code: 'PCB', number: 21, display: 'PCB', name: 'Partido Comunista Brasileiro', federation: null,
    colors: { fill: '#E75669', text: '#E75669', ink: '#120F0D', margin: ['#894C50', '#A74E57', '#C85360', '#E75669'], candidate: ['#6C3E41', '#844349', '#9C4950', '#B34C57', '#CE5260', '#E75669'], peak: '#EF7B85' },
  },
  CIDADANIA: {
    code: 'CIDADANIA', number: 23, display: 'Cidadania', name: 'Cidadania', federation: null,
    colors: { fill: '#DD579B', text: '#DD579B', ink: '#120F0D', margin: ['#844C65', '#A04E76', '#BF5489', '#DD579B'], candidate: ['#683E51', '#7F435F', '#95496E', '#AC4C7B', '#C5528C', '#DD579B'], peak: '#E77BAD' },
  },
  PRD: {
    code: 'PRD', number: 25, display: 'PRD', name: 'Partido Renovação Democrática', federation: null,
    colors: { fill: '#03A59B', text: '#03A59B', ink: '#120F0D', margin: ['#3C6A66', '#317C77', '#26918B', '#03A59B'], candidate: ['#335452', '#306460', '#2B746F', '#26827D', '#1B948E', '#03A59B'], peak: '#58B6AD' },
  },
  DC: {
    code: 'DC', number: 27, display: 'DC', name: 'Democracia Cristã', federation: null,
    colors: { fill: '#BA8400', text: '#BA8400', ink: '#120F0D', margin: ['#725D38', '#89682C', '#A27721', '#BA8400'], candidate: ['#5B4A2F', '#6E552B', '#7F6129', '#916B20', '#A67817', '#BA8400'], peak: '#C79C4F' },
  },
  PRTB: {
    code: 'PRTB', number: 28, display: 'PRTB', name: 'Partido Renovador Trabalhista Brasileiro', federation: null,
    colors: { fill: '#13AB50', text: '#13AB50', ink: '#120F0D', margin: ['#3D6D47', '#358047', '#28974A', '#13AB50'], candidate: ['#32573A', '#33673C', '#2F7841', '#2A8743', '#209A48', '#13AB50'], peak: '#5ABC73' },
  },
  PCO: {
    code: 'PCO', number: 29, display: 'PCO', name: 'Partido da Causa Operária', federation: null,
    colors: { fill: '#E85856', text: '#E85856', ink: '#120F0D', margin: ['#894D4A', '#A84F4B', '#C95453', '#E85856'], candidate: ['#6B3F3D', '#864340', '#9D4946', '#B44D4A', '#CF5351', '#E85856'], peak: '#F07C76' },
  },
  NOVO: {
    code: 'NOVO', number: 30, display: 'Novo', name: 'Partido Novo', federation: null,
    colors: { fill: '#E46212', text: '#E46212', ink: '#120F0D', margin: ['#865138', '#A4552F', '#C55D25', '#E46212'], candidate: ['#694230', '#82482C', '#9A4F2B', '#B05426', '#CB5C1E', '#E46212'], peak: '#EC8352' },
  },
  MOBILIZA: {
    code: 'MOBILIZA', number: 33, display: 'Mobiliza', name: 'Mobiliza', federation: null,
    colors: { fill: '#D859A8', text: '#D859A8', ink: '#120F0D', margin: ['#814D6B', '#9D4F7D', '#BB5594', '#D859A8'], candidate: ['#653F55', '#7C4466', '#924A75', '#A84D84', '#C15496', '#D859A8'], peak: '#E27CB8' },
  },
  DEMOCRATA: {
    code: 'DEMOCRATA', number: 35, display: 'Democrata', name: 'Democrata', federation: null,
    colors: { fill: '#00A974', text: '#00A974', ink: '#120F0D', margin: ['#3C6C55', '#317F5D', '#259569', '#00A974'], candidate: ['#325645', '#30664D', '#2F7657', '#29855F', '#1B986A', '#00A974'], peak: '#58BA8E' },
  },
  AGIR: {
    code: 'AGIR', number: 36, display: 'Agir', name: 'Agir', federation: null,
    colors: { fill: '#807CF8', text: '#807CF8', ink: '#120F0D', margin: ['#5A5A8D', '#6464AF', '#7271D5', '#807CF8'], candidate: ['#47496F', '#51538B', '#5D5DA4', '#6766BE', '#7571DC', '#807CF8'], peak: '#9697FB' },
  },
  PSB: {
    code: 'PSB', number: 40, display: 'PSB', name: 'Partido Socialista Brasileiro', federation: null,
    colors: { fill: '#B88500', text: '#B88500', ink: '#120F0D', margin: ['#725D37', '#87692C', '#A07821', '#B88500'], candidate: ['#594B2F', '#6C562B', '#7E6228', '#8F6C21', '#A57916', '#B88500'], peak: '#C69D4F' },
  },
  PV: {
    code: 'PV', number: 43, display: 'PV', name: 'Partido Verde', federation: null,
    colors: { fill: '#5FA50F', text: '#5FA50F', ink: '#120F0D', margin: ['#4F6A39', '#527C2F', '#5A9125', '#5FA50F'], candidate: ['#3E5531', '#46642C', '#4C742B', '#528224', '#5A941B', '#5FA50F'], peak: '#7EB753' },
  },
  PSOL: {
    code: 'PSOL', number: 50, display: 'PSOL', name: 'Partido Socialismo e Liberdade', federation: null,
    colors: { fill: '#999401', text: '#999401', ink: '#120F0D', margin: ['#646338', '#75712C', '#888323', '#999401'], candidate: ['#504F2F', '#5F5C2B', '#6C6A29', '#7A7621', '#8A8614', '#999401'], peak: '#ABA850' },
  },
  PCDOB: {
    code: 'PCDOB', number: 65, display: 'PCdoB', name: 'Partido Comunista do Brasil', federation: null,
    colors: { fill: '#E7566B', text: '#E7566B', ink: '#120F0D', margin: ['#894C51', '#A74E58', '#C85362', '#E7566B'], candidate: ['#6C3E41', '#844349', '#9C4853', '#B34C58', '#CE5163', '#E7566B'], peak: '#EF7B86' },
  },
  AVANTE: {
    code: 'AVANTE', number: 70, display: 'Avante', name: 'Avante', federation: null,
    colors: { fill: '#00A2AF', text: '#00A2AF', ink: '#120F0D', margin: ['#3C696E', '#327A82', '#268F99', '#00A2AF'], candidate: ['#345357', '#2F6368', '#2E7279', '#278089', '#1B929D', '#00A2AF'], peak: '#57B4BE' },
  },
  SOLIDARIEDADE: {
    code: 'SOLIDARIEDADE', number: 77, display: 'Solidariedade', name: 'Solidariedade', federation: null,
    colors: { fill: '#D17400', text: '#D17400', ink: '#120F0D', margin: ['#7D5737', '#985F2A', '#B66A1F', '#D17400'], candidate: ['#63462F', '#794F2A', '#8E5828', '#A26020', '#BA6B16', '#D17400'], peak: '#DB904F' },
  },
  UP: {
    code: 'UP', number: 80, display: 'UP', name: 'Unidade Popular', federation: null,
    colors: { fill: '#988D83', text: '#988D83', ink: '#120F0D', margin: ['#655F5B', '#736D66', '#857E75', '#988D83'], candidate: ['#504C4A', '#5D5954', '#6C6560', '#797169', '#888077', '#988D83'], peak: '#ABA29A' },
  },
};

const warned = new Set<string>();

/** Party do código (ou do candidato); código desconhecido → FALLBACK_PARTY e um único console.warn (AC-3.3-05). */
export function partyOf(ref: string | { party_code: string }): Party {
  const code = typeof ref === 'string' ? ref : ref.party_code;
  const party = PARTIES[code];
  if (party) return party;
  if (!warned.has(code)) {
    warned.add(code);
    console.warn(`[tema] partido sem cor: "${code}"; usando o fallback (§3.3.9)`);
  }
  return FALLBACK_PARTY;
}

/** Classe de contexto que expõe --p-* (§3.3.9). */
export function partyClass(party: Party): string {
  return party.number ? `party-${party.number}` : 'party-fallback';
}

/** Tinta de maior contraste sobre uma cor de dado (regra 6 de §3.3.1); o halo de reserva fica em pickInk. */
export function inkOn(hex: string): string {
  return pickInk(hex).ink;
}
